var getFileExtension = function (filePath) {
  return filePath.split('?')[0].split('.').pop();
};

module.exports = getFileExtension;
